module.exports = __webpack_public_path__ + "static/media/slide-children.0dc4c0ec.jpg";